export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_22-15b7dfe337e32d38590bfacd9ba66110.jpg";